import React, { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import UserForm from "./Components/UserForm";
import AppTabs from "../../../components/CustomTabs/AppTabs";
import ChangePasswordForm from "views/Client/AccountSetting/Components/ChangePasswordForm";
import ChangeEmailForm from "views/Client/AccountSetting/Components/ChangeEmailForm";
import { changeEmail, changePassword } from "store/slices/auth";
import { useDispatch } from 'react-redux';

const ClientUserManagement = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const cpRef = useRef();
    const ceRef = useRef();

    const [loading, setLoading] = useState(false);

    const submitChangePassword = async ({ confirmPass, newPass, id }) => {
        setLoading(true);
        if (confirmPass && newPass) {
            const result = await dispatch(changePassword({
                id: id,
                confirmPass: confirmPass,
                newPass: newPass
            }));
            if (result.payload) {
                cpRef && cpRef.current.resetForm();
            }
        }
        setLoading(false);
    };
    const submitChangeEmail = async ({ email, id }) => {
        setLoading(true);
        if (email) {
            const result = await dispatch(changeEmail({
                id: id,
                email: email
            }));
            if (result.payload) {
                ceRef && ceRef.current.resetForm();
            }
        }
        setLoading(false);
    };

    return (
        <AppTabs
            swipeable={false}
            tabs={[
                {
                    tabLabel: t('label.user_profile'),
                    tabContent: <UserForm isAdd={false} />,
                },
                {
                    tabLabel: t('label.change_password'),
                    tabContent: <React.Fragment>
                        <ChangeEmailForm
                            isSubmitting={loading}
                            onSubmit={submitChangeEmail}
                            formRef={ceRef}
                        />
                        <ChangePasswordForm
                            isSubmitting={loading}
                            onSubmit={submitChangePassword}
                            formRef={cpRef}
                        />
                    </React.Fragment>,
                }
            ]}
        />
    )
}

export default ClientUserManagement;
